<template>
  <!-- 发送传真 -->
  <div>
    <el-dialog
      :title="$t('transportDeliveryOrder.btnList.sendFax')"
      :visible.sync="dialogVisible"
      width="800px"
      class="splitDialog"
      @close="close"
    >
      <base-form
        v-model="baseData"
        :options="baseDataOptions"
        ref="baseData"
        label-width="105px"
      ></base-form>
      <vxe-grid
        style="margin-top: 20px"
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="tableData"
        :columns="column"
      >
      </vxe-grid>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="sendFax()" class="fixed-bottom-btn"
          >确认</el-button
        >
        <el-button size="medium" type="primary" @click="close" class="fixed-bottom-btn"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/logisticsCenter/transportDeliveryOrder';
  import { mapState } from 'vuex';
  import baseForm from '@/components/form/base-form';

  export default {
    props: {
      codeNumber: {
        type: String,
        default: '',
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      formData: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      baseForm,
    },
    data() {
      return {
        dialogVisible: false,
        baseData: {
          title: null, // 标题
          fax: null, // 传真号
          sender1: null, // 公司
          sender2: null, // 当前人
          receiver1: null, // 仓库名
          receiver2: null, // 仓库联系人
          sendfile: null, // 文件链接
          sendflag: null,
          ldc: null,
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      baseDataOptions() {
        return [
          {
            type: 'input',
            prop: 'ldc',
            label: this.$t('transportDeliveryOrder.sendFax.ldc'),
            span: 13,
          },
          {
            type: 'input',
            prop: 'fax',
            label: this.$t('transportDeliveryOrder.sendFax.fax'),
            required: true,
            span: 13,
          },
          {
            type: 'input',
            prop: 'receiver1',
            label: this.$t('transportDeliveryOrder.sendFax.receiver1'),
            disabled: true,
            span: 13,
          },
          {
            type: 'select',
            prop: 'sendflag',
            options: [
              { value: 0, label: '普通发送' },
              { value: 1, label: '优先发送（排到当前发送队列的首部）' },
            ],
            label: this.$t('transportDeliveryOrder.sendFax.sendflag'),
            required: true,
            span: 13,
          },
          {
            type: 'textarea',
            prop: 'title',
            label: this.$t('transportDeliveryOrder.sendFax.title'),
            required: true,
            span: 18,
          },
        ];
      },
      column() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: this.$t('table.index'), width: 90 }, // 序号
          { field: 'attachmentName', title: this.$t('upload.attachmentName') }, // 收款金额（本币）
        ];
      },
    },
    methods: {
      openDialog(data) {
        // 打开
        if (data.faxNo) {
          if (data.faxNo.indexOf('-') != -1) {
            let faxNoArr = data.faxNo.split('-');
            this.baseData.ldc = faxNoArr[0];
            this.baseData.fax = faxNoArr[1];
          } else {
            this.baseData.fax = data.faxNo;
          }
        }
        this.baseData.sender1 = this.userInfo.companyName;
        this.baseData.sender2 = this.userInfo.userName;
        this.baseData.receiver1 = data.outboundStorageName;
        this.baseData.receiver2 = data.contactPerson;
        this.baseData.sendflag = 0;
        this.getDetail(data.outboundNo);
        this.dialogVisible = true;
      },
      sendFax() {
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let hasChktableData = this.$refs.table.getCheckboxRecords();
            if (this.tableData.length == 1) {
              hasChktableData = this.$refs.table.getTableData().fullData;
            } else {
              if (hasChktableData.length == 0) {
                return this.$message({
                  showClose: true,
                  message: '请至少选择一条附件！',
                  type: 'error',
                });
              }
            }
            let sendfile = hasChktableData.map((item) => {
              return item.attachmentPath;
            });
            this.baseData.sendfile = sendfile.join('/');
            this.baseData.docType = 'DISTRIBUTION_OUTBOUND';
            this.baseData.docId = this.formData.id;
            this.baseData.docNo = this.formData.outboundNo;
            this.loading.startLoading();
            let list = [];
            hasChktableData.map((it) => {
              let obj = {};
              obj['dataNo'] = this.codeNumber;
              obj['downloadOrPrint'] = 'print';
              obj['headCompanyName'] = this.formData.companyName;
              obj['templateCode'] = it.templateCode;
              obj['templateUrl'] = it.attachmentKey;
              list.push(obj);
            });
            let params = {
              ...this.baseData,
              ic: 86,
              line: 0,
              status: 0,
              list: list,
            };
            this.$axios.post(API.SEND_FAX, params).then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.dialogVisible = false;
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          }
        });
      },
      getDetail(outboundNo) {
        //获取详细信息
        this.$axios.get(API.DETAIL_TRANSPORTDELIVERYORDER_API + outboundNo).then((res) => {
          if (0 == res.data.code) {
            let formData = res.data.data;
            this.customerName = formData.customerName;
            this.deliveryNote = formData.deliveryNote;
            let transport = res.data.data.deliveryTransportList[0];
            let product = res.data.data.outboundDetailList[0];
            let businessOrderQuantity =
              product.businessOrderQuantity || product.businessOrderPackage;
            let productInfo =
              product.productName + ' ' + businessOrderQuantity + product.productUnitName;
            let nameVoyageLicense = transport
              ? '车辆信息：' + transport.nameVoyageLicense + '，'
              : '';
            let freightInformation = transport
              ? transport.freightInformation
                ? transport.freightInformation
                : '备注'
              : '备注';
            // let customerName = this.customerName ? this.customerName : '';
            let storageCompanyName = storageCompanyName
              ? '【' + formData.storageCompanyName + '】'
              : '';
            this.first = storageCompanyName + '【' + outboundNo + '】' + productInfo + '等。';
            this.center =
              nameVoyageLicense +
              '【' +
              freightInformation +
              '】，请知晓。【' +
              this.userInfo.companyName +
              '】';
            this.baseData.title = this.first + this.center;
          }
        });
      },
      close() {
        // 弹窗关闭
        this.dialogVisible = false;
        Object.keys(this.baseData).map((item) => {
          return (this.baseData[item] = null);
        });
      },
    },
  };
</script>
